var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPlusDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.486,
    viewBox: "0 0 21.5 21.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9182",
    "data-name": "Group 9182",
    transform: "translate(-1000.25 -619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8312",
    "data-name": "Group 8312",
    transform: "translate(993.383 603.648) rotate(45)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M0,0H8.484",
    transform: "translate(27.903 2.999) rotate(45)",
    fill: "none",
    stroke: "#2b1e3f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M0,0H8.484",
    transform: "translate(33.903 3) rotate(135)",
    fill: "none",
    stroke: "#2b1e3f",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9181",
    "data-name": "Group 9181",
    transform: "translate(4.25 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M20.56,12.871A10.023,10.023,0,0,1,.75,10.733C.75,6.171,3.8,2.323,8.573.99",
    transform: "translate(996 620)",
    fill: "none",
    stroke: "#2b1e3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    "data-name": "Path 5355",
    d: "M7.865.75A9.235,9.235,0,0,1,17.1,9.985",
    transform: "translate(999.652 620)",
    fill: "none",
    stroke: "#2b1e3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    opacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPlusDefaultIcon);
export default __webpack_public_path__ + "static/media/black_plus_default_icon.4310da86da19cbfc9492204bdc6793a8.svg";
export { ForwardRef as ReactComponent };